<ejs-tooltip [cssClass]="actionType" [content]="tooltip">
  <button type="button" ejs-button [class]="actionType" class="e-flat e-round p-0" (click)="clicked.emit($event)">
    <i *ngIf="iconClassFa" [class]="iconClassFa" class="text-lg"></i>
    <ng-content select="[icon]"></ng-content>
  </button>
</ejs-tooltip>
